export default function AppDownLoadPage(){
    return <div>
        <h4 className = "mb-4">앱 다운로드</h4>
        <a href="/managerapp.zip">안드로이드 (managerapp.zip)</a>
    </div>
}